import placeholder from "./placeholder.png";

export default {
  placeholder
};



// WEBPACK FOOTER //
// ./src/assets/images/pdvend/index.js